
































import MessageForm from '@/components/MessageForm.vue'
import Modal from '@/layouts/Modal.vue'
import { addMessage, IMessage } from '@/store/messages'
import { QBtn } from 'quasar'
import Message from 'src/components/Message.vue'
import { Component, Prop, Vue } from 'vue-property-decorator'
import { IVxsPromise, vxsActionFetch } from 'vuex-xhr-state'
import { EPermission } from '@/laura-types'

@Component({
  components: {
    MessageForm,
    Message,
    QBtn,
    Modal,
  },
})
export default class Messages extends Vue {
  @Prop({ required: true, type: Array }) public messages!: IMessage[]
  @vxsActionFetch(addMessage) public addMessage!: (_: Partial<IMessage>) => IVxsPromise<void>
  public addModal = false
  public message = {
    content: '',
    type: 'info',
    label: '',
    title: '',
  }

  public openAddModal(): void {
    this.addModal = true
  }

  get showAdminActions(): boolean {
    return this.$can('update', EPermission.LIKA_ADMIN)
  }
}
